export const permissions = {
  groupAdmin: 0,
  user: 1,
  entityAdmin: 2,
};
